import angular from 'angular';
import uiRouter from 'angular-ui-router';
import collectionComponent from './collection.component';

let collectionModule = angular.module('collection', [
    uiRouter
])

.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('newCollection', {
            url: '/collections/new',
            component: 'collection',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN'],
                    redirectTo: 'home'
                }
            },
            resolve: {
            }
        })
        .state('editCollection', {
            url: '/collections/:id',
            component: 'collection',
            parent: 'main',
            data: {
                permissions: {
                    only: ['OPERATOR'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                user: (LoginService) => {
                    return LoginService.getCurrent();
                },
                collection: function(
                    CollectionsService,
                    LoginService,
                    $stateParams
                ) {
                    return Promise.all([
                        LoginService.getCurrent(),
                        CollectionsService.findById($stateParams.id, {
                            include: [
                                'employee',
                                {
                                    relation: 'spendings',
                                    scope: {
                                        include: ['spendingType']
                                    }
                                },
                                {
                                    relation: 'operativeSpendings',
                                    scope: {
                                        include: ['holder', 'vehicle', 'quote']
                                    }
                                },
                                {
                                    relation: 'receipts',
                                    scope: {
                                        include: [
                                            'client',
                                            {
                                                relation: 'paymentItems',
                                                scope: {
                                                    include: ['bankTx', 'check']
                                                }
                                            }
                                        ]
                                    }
                                },
                                'cashboxTransfers'
                            ]
                        })
                    ]).then(res => {
                        let user = res[0];
                        let collection = res[1];

                        let notAllowed = !user.isAdmin
                            && (collection.employeeId != user.employeeId);
                        if (notAllowed) {
                            return Promise.reject();
                        } else {
                            return collection;
                        }
                    });
                }
            }
        });
})
.component('collection', collectionComponent)
.name;

export default collectionModule;
